import {useMemo, useState} from "react";
import SubFilterOpenButton from "../SubFilterOpenButton/SubFilterOpenButton";
import stl from "./AsideBody.module.css";
import {CDN_LINK} from "@globalConfig";
import OpenMenuSelection from "../OpenMenuSelection/OpenMenuSelection";
import {isRangeFilter} from "@/pages/search/searchHooks/utils";
import RemoveFiltersNote from "../RemoveFiltersNote/RemoveFiltersNote";
import {useTranslation} from "@i18n";
import useIsMobile from "@hooks/useIsMobile";
import {trackEvents} from "@/common/events/events";

function AsideBody(
    {
        filters,
        handleOpenFilter,
        selectedOptions,
        handleFilterChange,
        tempSelectedOptions,
        dealFacet,
        handleDeleteFilters,
        setFilterOnMobile,
    }) {
    const {t} = useTranslation();
    const [showAllFiltersMobile, setShowAllFiltersMobile] = useState(false);
    const isMobile = useIsMobile();

    const isMakeSelected = useMemo(
        () => selectedOptions?.some((option) => option?.filterField === "make_id"),
        [selectedOptions]
    );

    const isModelSelected = useMemo(
        () => selectedOptions?.some((option) => option?.filterField === "model_id"),
        [selectedOptions]
    );

    const getFiltersCount = (filterName) => {
        const isRange = isRangeFilter(filterName);

        if (isRange) {
            const selectedOption = selectedOptions?.find(
                (option) => option?.filterField === filterName
            );

            return selectedOption
                ? `${selectedOption.range_values.from}-${selectedOption.range_values.to}`
                : null;
        }

        return selectedOptions?.filter(
            (option) => option?.filterField === filterName
        )?.length;
    };

    return (
        <>
            <div
                className={[
                    stl.wrapper,
                    showAllFiltersMobile ? stl.showAllFiltersMobile : undefined,
                ].join(" ")}
            >
                {dealFacet?.name && (
                    <div className={stl.dealFacetWrapper}>
                        <button
                            onClick={() => {
                                isMobile && setFilterOnMobile(false);
                                handleFilterChange(
                                    {filterField: "deal_id"},
                                    {id: dealFacet.id, name: dealFacet.name},
                                    true
                                );
                                trackEvents("browse_cars", {
                                    referral_location: "listing",
                                    browse_variant: "clearance_offers",
                                    variant_value: "null",
                                    category_path: null
                                })
                            }}
                            className="interActiveBackPurple"
                        >
                            {dealFacet?.name}
                            <img
                                width={24}
                                height={24}
                                src={CDN_LINK + "/assets/images/whtBck.svg"}
                                alt="arrow"
                            />
                        </button>
                    </div>
                )}

                {filters.length <= 4 ? (
                    <RemoveFiltersNote/>
                ) : (
                    filters?.map((filter, i) => {
                        const displayName = filter.displayName;
                        const filterName = filter?.filterField;

                        const count = getFiltersCount(filterName);
                        if (filterName === "model_id" && !isMakeSelected) return;
                        if (filterName === "trim_id" && !isModelSelected) return;

                        if (filterName === "condition_id") {
                            return (
                                <OpenMenuSelection
                                    key={i}
                                    filter={filter}
                                    tempSelectedOptions={tempSelectedOptions}
                                    selectedOptions={selectedOptions}
                                    isCampaign={false}
                                    isOpen
                                    options={filter.values}
                                    onChange={handleFilterChange}
                                    fieldName={filterName}
                                    selectedOption={selectedOptions?.filter(
                                        (option) => option?.filterField === filterName
                                    )}
                                    title={displayName}
                                    setFilterOnMobile={() => {
                                    }}
                                />
                            );
                        }

                        return (
                            <SubFilterOpenButton
                                key={i}
                                option={selectedOptions?.find(
                                    (option) => option?.filterField === filterName
                                )}
                                handleDeleteFilters={handleDeleteFilters}
                                isRange={isRangeFilter(filterName)}
                                isLoading={false}
                                count={count || null}
                                disabled={false}
                                name={displayName}
                                onClick={() => {
                                    handleOpenFilter(filter);
                                }}
                            />
                        );
                    })
                )}

                {filters.length > 4 && (
                    <div
                        className={[stl.mobileMoreBtn, "m-show"].join(" ")}
                        onClick={() => {
                            setShowAllFiltersMobile(!showAllFiltersMobile);
                        }}
                    >
            <span>
              {!showAllFiltersMobile
                  ? t("شاهد المزيد من خيارات البحث", {ns: "web_search"})
                  : t("إخفاء خيارات البحث الاخرى ", {ns: "web_search"})}
            </span>
                        <img
                            src={CDN_LINK + "/assets/images/arrAcc.svg"}
                            alt="arrow"
                            width={12}
                            height={7}
                        />
                    </div>
                )}
            </div>
        </>
    );
}

export default AsideBody;
